import { isAuthorized } from '@zg-rentals/auth-comet';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';
import { CometUserAuthenticationWebHandler_getUser_queryOptions } from '@zg-rentals/ts-capps-client-react-query';
import type { AuthCheckUserInfoDto } from '@zg-rentals/ts-capps-client';

export const Auth = defineAuthProvider<{ isInMobileWebView?: boolean }, AuthCheckUserInfoDto>({
  queryOptions: () => CometUserAuthenticationWebHandler_getUser_queryOptions({ pageWithSensitiveInformation: true }),
  isAuthorized: (user, props) => {
    return isAuthorized({
      mapUser: (mappedUser: AuthCheckUserInfoDto) => {
        // Exempt mobile webview users from 2FA requirement
        if (props?.isInMobileWebView) {
          return { ...mappedUser, isInitialMultiFactorAuthenticationRequired: false };
        }
        return mappedUser;
      },
      requireStrongAuthentication: true,
    })(user);
  },
});

export const { useAuth } = Auth;
